import { render } from "./ItemSigns.vue?vue&type=template&id=084e8162&scoped=true"
import script from "./ItemSigns.vue?vue&type=script&lang=js"
export * from "./ItemSigns.vue?vue&type=script&lang=js"

import "./ItemSigns.vue?vue&type=style&index=0&id=084e8162&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084e8162"]])

export default __exports__